/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { ButtonIcon as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Button' ),
	description: __( 'This block allows you to place an button.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Button' ),
	],
	parent: [ 'gutenify/buttons' ],
	example: {
		attributes: {
			image: {
				url: '',
				id: '',
			},
		},
	},
	attributes,
	edit,
	save,
	supports: {
		anchor: true,
		align: false,
		alignWide: false,
		typography: {
			fontSize: true,
			__experimentalFontFamily: true,
		},
	},
};

export { name, category, settings };
